import { SizeBorderWidthThick,SpaceLg, SpaceMd } from '@nxt-costco-com/forge-design-tokens';

export const mdSpacedBox = {
    display: 'flex',
    flexDirection: 'column',
    gap: SpaceMd
};

export const lgSpacedBox = {
    display: 'flex',
    flexDirection: 'column',
    gap: SpaceLg
};

export const headingPadding = {
    marginBottom: SizeBorderWidthThick
};

export const sectionHeaderPadding = {
    marginTop: SpaceLg,
    marginBottom: SizeBorderWidthThick
};
